import { render, staticRenderFns } from "./CusOrderDetail.vue?vue&type=template&id=0476627c&scoped=true&"
import script from "./CusOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CusOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CusOrderDetail.vue?vue&type=style&index=0&id=0476627c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476627c",
  null
  
)

export default component.exports